<template>
	<div class="user-schema-mapping-read-dispatcher">
		<div class="application-source-selection" v-if="isMappingSetupFinished">
			<div v-for="param in paramsToShow" :key="param.key">
				<ParamDispatcherDataProvider v-bind="$attrs" v-on="$listeners" :node="node" :param="param" :key="buildFieldKeyFunc(param)" />
			</div>
		</div>
	</div>
</template>

<script>
import ParamDispatcherDataProvider from '@/components/BlockEditor/BlockEditorParams/ParamDispatcherDataProvider';
import { mapGetters } from 'vuex';
import ParamsService from '@/utils/ParamsService';
import DynamicDataService from '@/utils/dynamic-data-service';
import { getWidgetFieldData } from '@/store/modules/widgets/getters';
export default {
	name: 'DynamicParamsReadActionDispatcher',
	components: {
		ParamDispatcherDataProvider,
	},
	props: {
		node: { type: Object },
		service: { type: Object },
		action: { type: Object },
		params: { type: Array },
		buildFieldKeyFunc: { type: Function },
		hasEditPermissions: { type: Boolean },
	},
	computed: {
		...mapGetters([getWidgetFieldData.fullPath]),
		alreadyChosenByMapperParamsKeys() {
			return (ParamsService.getParamsForMapping(this.service, this.action) || []).map((p) => p.key);
		},
		mapperData() {
			return (this[getWidgetFieldData.fullPath](this.node.user_schema_mappings_source_field_uuid) || {}).widgetField || {};
		},
		mapperMappings() {
			return this.mapperData?.metadata?.source?.mappings || [];
		},
		mapperMappingsKeys() {
			return this.mapperMappings.map((x) => x.originalKey);
		},
		paramsToShow() {
			return this.params?.filter((p) => !this.alreadyChosenByMapperParamsKeys.includes(p.key));
		},
		isMappingSetupFinished() {
			return DynamicDataService.isMappingSetupFinished(this.mapperData, this.service);
		},
	},
	data() {
		return {
			isClosed: false,
		};
	},
};
</script>

<style scoped lang="scss">
.user-schema-mapping-read-dispatcher {
	height: fit-content;
	max-height: 100%;

	.info-title {
		font-size: 14px;
		font-weight: 700;
	}
	.info-content {
		margin: 4px 0 8px 0;
		font-size: 12px;
	}

	.info-title,
	.info-content {
		color: var(--primary-font-color) !important;
	}

	&.is-closed {
		max-height: 0;
		overflow: hidden;
		transition: max-height 0.3s linear;
	}
}
</style>
